module.exports = __webpack_public_path__ + "static/img/d11t.885d9ccb.jpg";